import { v4 as uuidv4 } from 'uuid';
import { normalizeHexColor } from './richText.js';
import { normalizeStoredImageItem, revokeLocalImageUrl } from './localImage.js';
import { LOCAL_ASSET } from './localAssets.js';
import { getQiniuSignedUrl } from './qiniuMedia.js';

export const HEADER_INFO_CARD_V2_COMPONENT_TYPE = 'header-info-card-v2';
export const HEADER_INFO_CARD_V2_MODULE_TYPE = 'infoCardV2';

export const HEADER_INFO_CARD_V2_DEFAULT_HEIGHT = 300;
export const HEADER_INFO_CARD_V2_COMPACT_HEIGHT = 260;
export const HEADER_INFO_CARD_V2_DEFAULT_EDGE_SIZE = 45;
export const HEADER_INFO_CARD_V2_DEFAULT_AUTOPLAY_INTERVAL = 4000;
export const HEADER_INFO_CARD_V2_MAX_SLIDES = 9;

const DEFAULT_TITLE_COLOR = '#ffffff';
const DEFAULT_SUBTITLE_COLOR = '#ffffff';
const DEFAULT_EDGE_COLOR = '#2B5082';
const DEFAULT_DOT_COLOR = '#d0d0d0';
const DEFAULT_DOT_ACTIVE_COLOR = '#666666';

const SLIDE_TEXTS = [
	['一脉相承 实力爆款', 'CS7 PLUS耀世新生'],
	['全新美学设计', '智驾旗舰体验'],
	['实力之选', '即刻启程'],
];

function createSlideImage(index = 0) {
	const assets = [
		LOCAL_ASSET.headerInfoCardV2,
		...(LOCAL_ASSET.carousel || []),
	];
	return {
		id: `header-info-card-v2-image-${uuidv4()}`,
		filename: 'banner.jpg',
		previewUrl: assets[index % assets.length],
		url: '',
		local: false,
	};
}

export function createDefaultHeaderInfoCardV2Slide(index = 0) {
	const texts = SLIDE_TEXTS[index] || ['', ''];
	return {
		id: uuidv4(),
		image: createSlideImage(index),
		jumpLink: null,
		title: texts[0],
		subtitle: texts[1],
	};
}

export function createDefaultHeaderInfoCardV2Slides(count = 2) {
	const slides = [];
	for (let i = 0; i < count; i += 1) {
		slides.push(createDefaultHeaderInfoCardV2Slide(i));
	}
	return slides;
}

export function getHeaderInfoCardV2ImageUrl(image) {
	if (!image) return '';
	return getQiniuSignedUrl(image.previewUrl || image.url || '');
}

export function getHeaderInfoCardV2Defaults() {
	return normalizeHeaderInfoCardV2Data({});
}

export function isHeaderInfoCardV2Component(type) {
	return type === HEADER_INFO_CARD_V2_COMPONENT_TYPE;
}

function normalizeSlideImage(image, fallback) {
	if (!image?.previewUrl && !image?.url) {
		return fallback ? { ...fallback } : createSlideImage();
	}
	return normalizeStoredImageItem(image, fallback || createSlideImage());
}

function normalizeSlide(slide, fallback) {
	const base = fallback || createDefaultHeaderInfoCardV2Slide();
	return {
		id: slide?.id || uuidv4(),
		image: normalizeSlideImage(slide?.image, base.image),
		jumpLink: slide?.jumpLink?.type ? { ...slide.jumpLink } : null,
		title: typeof slide?.title === 'string' ? slide.title : (base.title || ''),
		subtitle: typeof slide?.subtitle === 'string' ? slide.subtitle : (base.subtitle || ''),
	};
}

function resolveSourceItems(data = {}) {
	if (Array.isArray(data.items) && data.items.length) {
		return data.items;
	}
	if (Array.isArray(data.slides) && data.slides.length) {
		return data.slides;
	}
	// 兼容旧版单图结构
	if (data.image?.previewUrl || data.image?.url) {
		return [{
			id: data.image.id || uuidv4(),
			image: data.image,
			jumpLink: data.jumpLink,
			title: data.title,
			subtitle: data.subtitle,
		}];
	}
	return [];
}

export function normalizeHeaderInfoCardV2Data(data = {}) {
	const fallbackSlides = createDefaultHeaderInfoCardV2Slides(2);
	const sourceItems = resolveSourceItems(data);
	const slides = sourceItems.length
		? sourceItems.map((slide, index) => normalizeSlide(slide, fallbackSlides[index % fallbackSlides.length]))
		: fallbackSlides;

	return {
		items: slides.slice(0, HEADER_INFO_CARD_V2_MAX_SLIDES),
		height: Math.max(80, Number(data.height) || HEADER_INFO_CARD_V2_DEFAULT_HEIGHT),
		autoplay: data.autoplay !== false,
		autoplayInterval: Math.max(
			1000,
			Number(data.autoplayInterval) || HEADER_INFO_CARD_V2_DEFAULT_AUTOPLAY_INTERVAL,
		),
		titleColor: normalizeHexColor(data.titleColor || DEFAULT_TITLE_COLOR),
		subtitleColor: normalizeHexColor(data.subtitleColor || DEFAULT_SUBTITLE_COLOR),
		edgeColor: normalizeHexColor(data.edgeColor || DEFAULT_EDGE_COLOR),
		dotColor: normalizeHexColor(data.dotColor || DEFAULT_DOT_COLOR),
		dotActiveColor: normalizeHexColor(data.dotActiveColor || DEFAULT_DOT_ACTIVE_COLOR),
	};
}

export function revokeHeaderInfoCardV2Images(data) {
	(data?.items || data?.slides || []).forEach((slide) => {
		revokeLocalImageUrl(slide?.image?.previewUrl);
	});
	revokeLocalImageUrl(data?.image?.previewUrl);
}
